import { connect } from "react-redux";
import ExternalUserList from "./ExternalUserList";
import { bindActionCreators } from "redux";
import { getApprovedSaleListing } from "services/redux/sales/contractListing/action";
import { getExternalUsersList } from "services/redux/tickets/createTicket/action";

import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  postSalesList: state.contractListingReducer.contractpostSalesList,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
  getExternalUserData: state.createTicketReducer.getExternalUserData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      getApprovedSaleListing,
      getExternalUsersList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ExternalUserList);
